import React from "react";
import { Tabs } from "antd";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageHeader from "../shared/PageHeader";
import useAccounts from "./useAccounts";
import JournalTab from "./JournalTab";
import AccountsTab from "./AccountsTab";
import AccountSheet from "./AccountSheet";
import TrialBalanceTab from "./TrialBalanceTab";
import PeriodsTab from "./PeriodsTab";

const BASE = "/user/accounting/journal";

const TABS = [
  { key: "journal", path: BASE, label: "Journal" },
  { key: "accounts", path: `${BASE}/accounts`, label: "Accounts (Konten)" },
  {
    key: "trial-balance",
    path: `${BASE}/trial-balance`,
    label: "Trial balance (Summen- und Saldenliste)"
  },
  { key: "periods", path: `${BASE}/periods`, label: "Periods" }
];

// Journal & accounts: the tabs are real sub-routes so a Kontoblatt or a period list can be
// linked to from other modules.
const Journal = () => {
  const { t } = useTranslation("accounting");
  const history = useHistory();
  const { pathname } = useLocation();
  const accounts = useAccounts();

  const active =
    [...TABS].reverse().find(tab => pathname === tab.path || pathname.startsWith(`${tab.path}/`))
      ?.key || "journal";

  return (
    <div>
      <PageHeader
        title={t("Journal & accounts")}
        subtitle={t("Every booking (Buchungssatz), the chart of accounts and the monthly closing.")}
      />
      <Tabs
        activeKey={active}
        onChange={key => history.push(TABS.find(tab => tab.key === key).path)}
        items={TABS.map(tab => ({ key: tab.key, label: t(tab.label) }))}
      />
      <Switch>
        <Route
          path={`${BASE}/accounts/:number`}
          render={() => <AccountSheet accounts={accounts} />}
        />
        <Route path={`${BASE}/accounts`} render={() => <AccountsTab accounts={accounts} />} />
        <Route path={`${BASE}/trial-balance`} component={TrialBalanceTab} />
        <Route path={`${BASE}/periods`} component={PeriodsTab} />
        <Route path={BASE} render={() => <JournalTab accounts={accounts} />} />
      </Switch>
    </div>
  );
};

export default Journal;
